import React from 'react'
import "./styles.scss"
function Intro() {

    return (
        <section className="home__intro">
            <div className="home__intro__content">
                <h5 >What Happened!</h5>
                <p>How to create mobile-optimized videos in minutes. Not a designer,
                every team makes a lot of videos Can be trimmed. Take the first
                step to your brand's success. How to create
            mobile-optimized videos in minutes.</p>
            </div>
        </section>
    )
}

export default Intro
